module.exports = __webpack_public_path__ + "img/left_md_4.0ec6a761.jpg";